import Config from './Config';

// Save the original fetch function
const originalFetch = window.fetch;

// List of endpoints to exclude
const excludeHeadersFor = [
  '/login/authenticateUser',
  '/profDegreeMaster/getAllProfDegreeMasters',
  '/genderMaster/getAllGenders',
  '/countryMaster/getallCountries',
  '/user/getallActiveDoctors',
  '/patientAPI/registerNewPatient',
  '/user/addOrUpdate',
  '/user/validateDetail',
  '/user/emailIdExists',
  '/user/forgotpassword'
];

// Helper function to check if the URL should exclude headers
const shouldExcludeHeaders = (url) => {
  return excludeHeadersFor.some(endpoint => url.includes(endpoint));
};

// Override the fetch function
window.fetch = async (url, options = {}) => {
  // Check if the URL is in the exclusion list
  const exclude = shouldExcludeHeaders(url);

  if (!exclude) {
    // Get headers from Config if not in exclusion list
    const headers = Config.getHeaders();
    // Merge the provided headers with the global headers
    options.headers = {
      ...headers,
      ...options.headers,
    };
  }

  // Call the original fetch function with the modified options
  return originalFetch(url, options);
};
